import React from 'react';

import { Drawer } from 'antd';

import {
  PackageHeaderDrawer,
  PackageContentDrawer,
} from 'pages/product-full-view/components';

import { useGetCurrentProductHierarchyDetails } from 'pages/product-full-view/hooks';

const widthDrawer = 845;

const PackageContent = ({ visible, onClose }) => {
  const { data: currentHierarchyShortDetails } =
    useGetCurrentProductHierarchyDetails();

  return (
    <Drawer
      title={<PackageHeaderDrawer detail={currentHierarchyShortDetails} />}
      placement='right'
      onClose={onClose}
      visible={visible}
      key='right'
      mask={false}
      getContainer={false}
      style={{
        height: 'calc(100vh - 306px)',
        position: 'fixed',
      }}
      width={widthDrawer}
      closable
    >
      <PackageContentDrawer
        productItems={currentHierarchyShortDetails?.productItems}
      />
    </Drawer>
  );
};
export default PackageContent;
